import controller from './thing-name.controller';

const template = require('./thing-name.html');

export default {
    bindings: {
        name: '<',
        onUpdate: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-name/thing-name.component.js